import React from 'react';
import { Button } from '../Button';
import { Link } from 'react-router-dom';

interface HeroProps {
  consultationLink: string;
}

export const Hero: React.FC<HeroProps> = ({ consultationLink }) => {
  return (
    <section className="bg-gradient-to-r from-blue-600 to-blue-800 text-white min-h-[90vh] relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div className="flex justify-between items-center py-8">
          <a href="https://icpedge.com" className="w-48">
            <img 
              src="/logo.png" 
              alt="ICP EDGE Logo" 
              className="w-full h-auto brightness-0 invert"
            />
          </a>
          <div className="flex items-center gap-6">
            <Link 
              to="/find-your-edge" 
              className="text-white hover:text-blue-100 transition-colors font-semibold"
            >
              Find Your Edge
            </Link>
            <Link 
              to="/tools/conversion-unlocker" 
              className="text-white hover:text-blue-100 transition-colors font-semibold"
            >
              Fix Conversion Blockers
            </Link>
            <Button primary href={consultationLink}>Partner With Us</Button>
          </div>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center py-16">
          <div>
            <h1 className="text-5xl font-bold mb-6">
              Superpowers for your <br />CX Consultancy
            </h1>
            <p className="text-2xl text-blue-100 mb-8">
              Actionable insights your clients will love and your competitors can't match.
            </p>
          </div>

          <div className="relative">
            <div className="aspect-square rounded-lg overflow-hidden shadow-2xl">
              <img 
                src="https://stackblitz.com/storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBN3Y0eHc9PSIsImV4cCI6bnVsbCwicHVyIjoiYmxvYl9pZCJ9fQ==--c3b4c5cb3a9021b8fe9eaa596cfd497ff634f95e/Depositphotos_751219546_XL-min.jpg"
                alt="Professional consultants analyzing complex customer journey data" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -inset-4 bg-blue-500/10 rounded-lg -z-10 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};